export interface CronogramaActividadesModel {
  fecha_apertura: string;
  fecha_cierre: string;
  fecha_informe: string;
}

export const initialValuesCronogramaActividadesModel = {
  fecha_apertura: "",
  fecha_cierre: "",
  fecha_informe: "",
};
